import { GraphSummariesContext } from 'contexts/GraphSummaries';
import { useContext } from 'react';

const useGraphSummaries = () => {
  return useContext(GraphSummariesContext);
};

export default useGraphSummaries;
